module.exports = __webpack_public_path__ + "assetsclientes/img/github.c39c85a1.png";